import { render, staticRenderFns } from "./ServerBuddy.vue?vue&type=template&id=c7891e94&scoped=true"
import script from "./ServerBuddy.vue?vue&type=script&lang=ts"
export * from "./ServerBuddy.vue?vue&type=script&lang=ts"
import style0 from "./ServerBuddy.vue?vue&type=style&index=0&id=c7891e94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7891e94",
  null
  
)

export default component.exports